
import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import { AgeGroup, AgeGroupValues, Under13AgeGroup } from '@best-athletes/ba-types';
import { VuetifyMixin, CurrentAthleteMixin, StripeMixin,BAIconsMixin } from '../../../mixins';
import { AthleteMetric, PerformanceCategory, getPerformanceCategoryValues, DevelopmentalAge } from '@/../types/enums';
import { AthleteAssessmentDataModel } from '../../../models/athlete/AthleteAssessmentDataModel'
import CompareAgeGroupSelector from './CompareAgeGroupSelector.vue';
import AssessmentDataInfoProvider from '../../hoc/AssessmentDataInfoProvider.vue';
import Dialog from '../../ui/Dialog.vue';
import ProgressBar from '../../charts/ProgressBar.vue';
import ComparisonBarChart from '../../charts/ComparisonBarChart.vue';
import PerformanceLevelPreview from './PerformanceLevelPreview.vue';
import { athleteProfile, comparativeDataStore, comparativeDataV2SampleDataStore } from '../../../store';
import { performanceCategoryToLabel } from '../../../pipes/enum.pipes';
import RoundedButton from "@/components/forms/RoundedButton.vue";
import { ProductModel } from '@/models/product/ProductModel';
import ProductInfoProvider from "@/components/hoc/ProductInfoProvider.vue";
import SubscriptionInfoProvider from "@/components/hoc/SubscriptionInfoProvider.vue";

@Component({
	components: {
		AssessmentDataInfoProvider,
		ComparisonBarChart,
		CompareAgeGroupSelector,
		Dialog,
		ProgressBar,
		PerformanceLevelPreview,
		RoundedButton,
		ProductInfoProvider,
		SubscriptionInfoProvider
	}
})
export default class AthleteComparativeDataSummary extends Mixins(VuetifyMixin, CurrentAthleteMixin, StripeMixin, BAIconsMixin){
	@Prop({type: Boolean, default: false}) loading: boolean;
	@Prop() assessmentData: AthleteAssessmentDataModel;
	@Prop() metric: AthleteMetric;
	@Prop({type: Boolean, default: false}) useSampleData: boolean;

	showDevelopmentalAgeDialog: boolean = false;
	showPerformanceDialog: boolean = false;

	@Watch('assessmentData', { immediate: true })
	assessmentDataChanged(): void {
		this.updateGroups(this.CompareGroups)
	}

	get AvailableCompareGroups(): AgeGroup[]{
		return AgeGroupValues;
	}
	get ComparativeDataStore(): typeof comparativeDataV2SampleDataStore | typeof comparativeDataStore{
		if(this.useSampleData){
			return comparativeDataV2SampleDataStore;
		}
		return comparativeDataStore;
	}
	get CompareGroups(): AgeGroup[]{
		return this.FeatureAvailable ? this.ComparativeDataStore.compareGroups : [AgeGroup.U13, AgeGroup.O20];
	}
	set CompareGroups(newGroups: AgeGroup[]){
		this.updateGroups(newGroups)
	} 

	get ComparativeDataLoading(): boolean{
		return this.ComparativeDataStore.ComparativeDataLoading;
	}

	get DevelopmentalAge(): DevelopmentalAge | null{
		if(this.assessmentData){
			return this.assessmentData.developmentalCategory;
		}
		return null;
	}
	get MetricPerformanceCategory(): string | null{
		if(this.ComparativeDataStore.ComparisonReady){
			return performanceCategoryToLabel(this.ComparativeDataStore.Comparison[this.metric]);
		}
		return null;
	}

	get MyAgeGroup(): AgeGroup | Under13AgeGroup | null{
		return athleteProfile.AthleteAgeGroup;
	}
	get AthleteAgeGroupLabel(): string | null{
		return athleteProfile.AthleteAgeGroupLabel;
	}
	get AthleteAgeGroupIsUnderU13(): boolean{
		return athleteProfile.AthleteAgeGroupIsUnderU13;
	}

	get Over18(): boolean{
		return this.ComparativeDataStore.Over18;
	}

	updateGroups(ageGroups: AgeGroup[]): void{
		this.ComparativeDataStore.setComparativeGroups({
			assessmentId: this.assessmentData.id,
			ageGroups: ageGroups,
			athleteId: this.CurrentAthleteId,
		});
	}

	get PerformanceCategories(): PerformanceCategory[]{
		return getPerformanceCategoryValues(this.Over18);
	}

	async navigateToPurchase(product: ProductModel): Promise<void> {
		this.buyProduct('Buy Comparative Data', product, this.CurrentAthleteId);
	}

	get FeatureAvailable(): boolean {
		return this.ComparativeDataStore.featureAvailable;
	}
}
